import { render, staticRenderFns } from "./clickplay.vue?vue&type=template&id=5def2723&scoped=true&"
import script from "./clickplay.vue?vue&type=script&lang=js&"
export * from "./clickplay.vue?vue&type=script&lang=js&"
import style0 from "./clickplay.vue?vue&type=style&index=0&id=5def2723&prod&scoped=true&lang=css&"
import style1 from "./clickplay.vue?vue&type=style&index=1&id=5def2723&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5def2723",
  null
  
)

export default component.exports